import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input, OnChanges,
  OnDestroy,
  OnInit,
  Renderer2, SimpleChanges,
} from '@angular/core';
import {Router} from "@angular/router";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {multiLinkMixin} from "../../mixins/multi-link.mixin";


function isWordLink(tar: any): boolean {
  return tar instanceof HTMLAnchorElement && tar.className === 'wordlink';
}

@Component({
  selector: 'app-link-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container #container></ng-container>
    <div [innerHTML]="content | keepHtml"></div>
  `,
})
export class LinkContentComponent extends multiLinkMixin implements OnInit, OnDestroy , OnChanges {
  // @ViewChild('container', {read: ViewContainerRef}) container!: ViewContainerRef;
  @Input() content: string | null = null;

  private unlisten: (() => void) | null = null;

  constructor(
    public router: Router,
    public dynamicSvc: DynamicComponentService,
    public lm: LayoutMgrService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc, lm);
  }

  ngOnInit(): void {
    this.unlisten = this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
      let tar = event.target;

      // TODO: tar.className === 'hanja-size' 는 추후에 제거해야할지 고민이 필요. 링크 안의 테그가 다양해지면 매번 여기에 추가하는 것도 번거로움.
      if (isWordLink(tar) || (tar.className === 'hanja-size' && isWordLink(tar.parentElement))) {

        // 링크 안에 한자를 클릭한 경우에는 부모 요소로 대체한다.
        if ((tar.className === 'hanja-size' && isWordLink(tar.parentElement))) {
          tar = tar.parentElement;
        }

        event.preventDefault();
        event.stopPropagation();
        this.globalEventSvc.Click(event, true);

        console.log('anchor click = ', event, event.target.innerText);

        const url = decodeURI(tar.pathname);
        console.log('url = ', url);

        const href = tar.getAttribute('href');
        if (href) {
          const dispWord = event.target.innerText.replace(/[:_\/-]/g, "");
          console.warn('dispWord = ', dispWord);
          // TODO:
          if (this.lm.vcRef) {
            this.OpenMultiLink(href, dispWord).subscribe();
          }
          else {
            console.error('LinkContentComponent: this.lm.vcRef is null');
          }
        }
        else {
          throw new Error('LinkContentComponent: href is null');
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.unlisten) {
      this.unlisten();
      this.unlisten = null;
    }
  }

  /**
   * content 값의 갱신 여부를 확인하기 위해서 추가한 함수
   * ToDo: 차후에 삭제할 것
   */
  ngOnChanges(changes: SimpleChanges): void {
    const change = changes['content'];

    // if (change) {
    //   console.warn('LinkContentComponent::ngOnChanges() changes[content] =', change, change.previousValue, change.currentValue);
    // }
    // else {
    //   console.warn('LinkContentComponent::ngOnChanges() changes[content] =', change);
    // }
  }
}

